import { lazy, Suspense, useEffect, useState } from "react";

const MarqueeComponent = lazy(() =>
  import("react-fast-marquee").then((module) => ({
    default: module.default,
  })),
);

type MarqueeProps = {
  children: React.ReactNode;
  autoFill?: boolean;
  speed?: number;
  delay?: number;
  pauseOnHover?: boolean;
  pauseOnClick?: boolean;
  direction?: "left" | "right";
  className?: string;
};

export function Marquee({ children, className, ...props }: MarqueeProps) {
  // react-fast-marquee touches `document` at import time, which throws during
  // SSR and turns the whole response into a 500, so it is only loaded once the
  // component is mounted in the browser.
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  const staticContent = (
    <div className={`flex items-center overflow-hidden ${className || ""}`}>
      {children}
    </div>
  );

  if (!isMounted) return staticContent;

  return (
    <Suspense fallback={staticContent}>
      <MarqueeComponent className={className} {...props}>
        {children}
      </MarqueeComponent>
    </Suspense>
  );
}
